"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.fields = exports["default"] = exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['id', 'label', 'showTargetLabel', 'allowUserItem', 'min', 'max', 'correctItems'];
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.min !== undefined && values.min < 0) {
    errors.min = 'Min should be a positive number';
  }
  if (values.max !== undefined && values.max < 1) {
    errors.max = 'Max should be more than 1';
  }
  if (values.min && values.max && values.min > values.max) {
    errors.min = 'Min should be not more than max';
  }
  return errors;
};
var Component = exports.Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "toggleCorrectItem", function (id) {
      var correctItems = _this.props.fields.correctItems;
      correctItems.onChange((0, _xor2["default"])(correctItems.value, [id]));
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$fields = this.props.fields,
        showTargetLabel = _this$props$fields.showTargetLabel,
        allowUserItem = _this$props$fields.allowUserItem,
        min = _this$props$fields.min,
        max = _this$props$fields.max,
        correctItems = _this$props$fields.correctItems;
      var _this$props$extraProp = this.props.extraProps.values,
        sources = _this$props$extraProp.sources,
        allowCorrectAnswers = _this$props$extraProp.allowCorrectAnswers;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showTargetLabel))), " Show target label")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        type: "number",
        field: min,
        label: "Min required items"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        type: "number",
        field: _objectSpread(_objectSpread({}, (0, _pick2["default"])(max, ['value', 'touched', 'error'])), {}, {
          onChange: function onChange(e) {
            var value = e.target.value;
            max.onChange(value === '' ? undefined : value);
          }
        }),
        label: "Max required items"
      }))), allowCorrectAnswers ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: correctItems,
        label: "Correct items"
      }, sources.map(function (source) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: source.id,
          className: "checkbox",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          checked: correctItems.value && correctItems.value.includes(source.id),
          onChange: _this2.toggleCorrectItem.bind(_this2, source.id)
        }), ' ', (0, _cccisdSurveyCommon.stripTags)(source.label)));
      }))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(allowUserItem))), " Allow user-added items")));
    }
  }]);
  return Component;
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  fields: _propTypes["default"].object,
  extraProps: _propTypes["default"].object
});
var _default = exports["default"] = {
  name: 'Target',
  component: Component,
  validate: validate,
  fields: fields,
  initialValues: {
    showTargetLabel: true,
    min: 0
  }
};